import { Button, Grid } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';

export default function ExportButton(props: any) {
    const { machineScan, machineActive, disableExportButton } = props
    const [exportButtonClicked, setExportButtonClicked] = useState<boolean>(false);
    const [dots, setDots] = useState<string>("");
    const { t } = useTranslation();

    const styles = {
        CircularProgress: {
            mr: 1,
            color: "#FFFFFF"
        },
        dotsContainer: {
            display: 'inline-block',
            width: '24px',  // Fixed width for the dots
            textAlign: 'left'
        }
    }

    useEffect(() => {
        if (exportButtonClicked && !machineActive) {
            setExportButtonClicked(false)
        }
    }, [exportButtonClicked, machineActive, setExportButtonClicked])

    // Animate the dots when the button is clicked and the machine is active
    useEffect(() => {
        let dotsInterval: NodeJS.Timeout;

        if (exportButtonClicked && machineActive) {
            dotsInterval = setInterval(() => {
                setDots(prevDots => {
                    if (prevDots.length >= 3) return "";
                    return prevDots + ".";
                });
            }, 500); // Change dot every 500ms
        }

        return () => {
            if (dotsInterval) clearInterval(dotsInterval);
        };
    }, [exportButtonClicked, machineActive]);

    if (!machineActive) {
        return (
            <Grid item xl={5.25} xs={5.25} pt={2} pb={3}>
                <Button
                    className="Upload-Export-Blue"
                    disabled={disableExportButton}
                    fullWidth
                    onClick={() => {
                        machineScan("export")
                        setExportButtonClicked(true)
                    }}
                >
                    {t('control.inputs.buttons.export')}
                </Button>
            </Grid>
        )
    } else {
        return (
            <Grid item xl={5.25} xs={5.25} pt={2} pb={3}>
                <Button
                    className="Upload-Export-Blue"
                    disabled
                    fullWidth
                    onClick={() => { machineScan("export") }}
                >
                    {exportButtonClicked ? 
                        <>
                            {t('control.inputs.buttons.exporting')}<Box component="span" sx={styles.dotsContainer}>{dots}</Box>
                        </>
                        :
                        <CircularProgress size={20} sx={styles.CircularProgress} />
                }
                </Button>
            </Grid>
        )
    }
}